import React, { Component } from 'react';
import { getJSONFromURL } from '../Utility/helpers';
import { Loader } from 'semantic-ui-react';
import axios from 'axios';
import { LOCAL_ENDPOINTS } from '../config';
import './Constants.css';
import * as api from '../Utility/api';

class VerifiedPage extends Component {
  constructor(props){
    super(props)
    this.state = {
      code: '',
      tokens: {},
      tenants_from_xero: [],
      export_options: [],
      CLIENT_ID: "",
      network_state: true,
    }
    this.fetchTokens = api.fetchTokens.bind(this);
    this.storeXeroResponseCode = api.storeXeroResponseCode.bind(this);
  }

  componentDidMount = async () => {

    let result = await axios({
      method: "GET",
      url: LOCAL_ENDPOINTS.getClientID
    })

    if (!result.data.Success) {
      alert(result.data.Message)
    } else {
      this.setState({CLIENT_ID: result.data.CLIENT_ID})
    }

    let url = window.location.href;
    let shortened = url.split("?").pop();

    let my_params = getJSONFromURL(shortened);
    
    // KELVIN WIP
    let code = my_params.code;
    await this.storeXeroResponseCode({ body: JSON.stringify({ "code": code, "redirect_uri": url }) });

    // this.setState({ code });    
    // const tokens = await this.fetchTokens(code);
    // this.setState({ tokens });
    // localStorage.setItem("access_token", tokens.access_token);
    // this.props.history.push('/main');
  }

  render() {
    return(
      <div className="verified-loader">
        <Loader active inline="centered">Access token stored successfully! You can now close this browser tab and execute internal scripts.</Loader>
      </div>
    )
  }
}

export default VerifiedPage;